<a tabindex="0"><ng-content></ng-content></a>
